import { useState } from 'react';
import styled from '@emotion/styled';

interface InfoTipProps {
  text: string;
  placement?: 'top' | 'bottom';
  wide?: boolean;
}

const Wrap = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  cursor: help;
`;

const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #e5e5e5;
  color: #626262;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
  &:hover {
    background: #d3d3d3;
  }
`;

const Tooltip = styled.div<{ $placement: 'top' | 'bottom'; $wide: boolean }>`
  position: absolute;
  ${(p) => (p.$placement === 'bottom' ? 'top: calc(100% + 8px);' : 'bottom: calc(100% + 8px);')}
  left: 50%;
  transform: translateX(-50%);
  width: ${(p) => (p.$wide ? '320px' : '260px')};
  background: #323232;
  color: #ffffff;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  z-index: 50;
  pointer-events: none;
`;

const Arrow = styled.div<{ $placement: 'top' | 'bottom' }>`
  position: absolute;
  ${(p) =>
    p.$placement === 'bottom'
      ? 'bottom: 100%; border-bottom-color: #323232;'
      : 'top: 100%; border-top-color: #323232;'}
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
`;

export default function InfoTip({ text, placement = 'top', wide = false }: InfoTipProps): React.JSX.Element {
  const [show, setShow] = useState(false);

  return (
    <Wrap onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <Icon>?</Icon>
      {show && (
        <Tooltip $placement={placement} $wide={wide}>
          {text}
          <Arrow $placement={placement} />
        </Tooltip>
      )}
    </Wrap>
  );
}
